module.exports = __webpack_public_path__ + "img/15.cloud-light.c87ba169.svg";